import { _ } from "libs";

import React from "react";
import { WaitingReservation } from "../types";
import NoResults from "./noResults";
import WaitingReservationItemLarge from "./items/reservation/waiting";

const ReservationItem = ({
	waitingReservation,
	extraClass = "",
	onDeleteClick,
}: {
	waitingReservation: WaitingReservation;
	extraClass?: string;
	onDeleteClick: (uuid: string) => void;
}) => {
	return (
		<WaitingReservationItemLarge
			waitingReservation={waitingReservation}
			onDeleteClick={onDeleteClick}
			extra={extraClass}
		/>
	);
};

const WaitingReservationsList = ({
	reservations,
	onDeleteClick,
}: {
	reservations: WaitingReservation[];
	onDeleteClick: (uuid: string) => void;
}) => {
	return (
		<div className="table reservations">
			{reservations.length > 0 ? (
				reservations.map((reservation, index) => {
					return (
						<div className="cell" key={index}>
							<ReservationItem waitingReservation={reservation} onDeleteClick={onDeleteClick} />
						</div>
					);
				})
			) : (
				<NoResults text={_("reservations.noResults")} />
			)}
		</div>
	);
};

export default WaitingReservationsList;
